module.exports = __webpack_public_path__ + "img/阴香根.ff682057.jpg";